// extracted by mini-css-extract-plugin
export default {"mainWrapper":"CommonCard_mainWrapper__aZTm0"};